/**
 * Header-Verhalten: mobile Navigation, Suche im Kopf und Scroll-Zustand.
 * Ausgangszustand ist ohne JS bedienbar — die Nav ist nur zugeklappt, nicht
 * weg, und die Suche ist ein <details> mit einem normalen Formular darin.
 */
(function () {
  'use strict';

  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.getElementById('nav-mobile');
  var suche = document.querySelector('[data-header-search]');

  function sucheZu(fokusZurueck) {
    if (!suche || !suche.open) return;
    suche.open = false;
    if (fokusZurueck) suche.querySelector('summary').focus();
  }

  function menueZu(fokusZurueck) {
    if (!toggle || !nav || nav.hasAttribute('hidden')) return;
    nav.setAttribute('hidden', '');
    toggle.setAttribute('aria-expanded', 'false');
    if (fokusZurueck) toggle.focus();
  }

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var willOpen = nav.hasAttribute('hidden');

      if (willOpen) {
        sucheZu(false); /* nie zwei Klappen uebereinander */
        nav.removeAttribute('hidden');
      } else {
        nav.setAttribute('hidden', '');
      }

      toggle.setAttribute('aria-expanded', String(willOpen));
    });
  }

  if (suche) {
    var feld = suche.querySelector('[data-suchfeld-eingabe]');
    var ausloeser = suche.querySelector('summary');

    /* Auf- und Zuklappen selbst uebernehmen, statt auf das `toggle`-Ereignis
       zu warten: iOS oeffnet die Bildschirmtastatur nur, wenn der Fokus noch
       im selben Tipp gesetzt wird. `toggle` kaeme einen Takt zu spaet.
       Enter und Leertaste auf dem <summary> loesen ebenfalls `click` aus. */
    ausloeser.addEventListener('click', function (event) {
      event.preventDefault();
      var auf = !suche.open;
      suche.open = auf;
      if (!auf) return;
      menueZu(false);
      if (feld) {
        feld.focus();
        feld.select();
      }
    });

    /* Klick oder Tipp daneben schliesst, wie bei jedem Aufklapp-Menue. */
    document.addEventListener('click', function (event) {
      if (suche.open && !suche.contains(event.target)) sucheZu(false);
    });

    /* Fokus verlaesst die Suche (Tab, Umschalt+Tab): zuklappen (PR-04).
       Sonst blieb das Panel offen und lag ueber genau den Elementen, die als
       Naechstes den Fokus bekamen — auf der Startseite verdeckte es die
       Hero-Knoepfe vollstaendig (WCAG 2.4.11).

       Den Fokus NICHT zuruecksetzen: Er ist schon beim naechsten Element.

       Nur bei einem Ziel ausserhalb. Ohne Ziel (`relatedTarget` leer) ging
       der Fokus ins Nichts: Fenster gewechselt, Klick auf eine leere Flaeche
       oder das Feld wurde beim Zuklappen selbst versteckt. Den Klick regelt
       der Handler oben; beim Zurueckkehren ins Fenster soll die Suche so
       offen sein, wie man sie verlassen hat. */
    suche.addEventListener('focusout', function (event) {
      var ziel = event.relatedTarget;
      if (!suche.open || !ziel || suche.contains(ziel)) return;
      sucheZu(false);
    });
  }

  /* Escape schliesst, was offen ist, und gibt den Fokus an den Ausloeser
     zurueck. Offene Vorschlaege schliesst das Suchfeld selbst zuerst (es
     haelt das Ereignis an) — erst das zweite Escape klappt die Suche zu. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (suche && suche.open) {
      sucheZu(true);
    } else if (nav && !nav.hasAttribute('hidden')) {
      menueZu(true);
    }
  });

  var header = document.querySelector('[data-site-header]');

  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();

/**
 * Kopfleiste, die beim Hochscrollen zurueckkommt.
 *
 * Warum ueberhaupt: `.site-header` trug zwar `position: sticky`, blieb aber
 * nie stehen. Ein Sticky-Element wandert nur innerhalb seines Elternteils —
 * und der Section-Wrapper ist exakt so hoch wie der Header selbst. Null
 * Spielraum, also null Haftung. Deshalb haftet jetzt die ganze Kopfgruppe.
 *
 * Verhalten (nur bis 899 px): Runterscrollen blendet Ankuendigung und Header
 * aus, Hochscrollen holt sie zurueck. Auf dem Handy ist der erste Bildschirm
 * knapp — eine dauerhaft sichtbare Leiste kostet dort mehr, als sie nuetzt.
 *
 * Ganz oben ist die Leiste immer da, damit die Seite nicht kopflos beginnt.
 */
(function () {
  'use strict';

  var gruppe = document.querySelector('.shopify-section-group-header-group');
  if (!gruppe) return;

  var mobil = window.matchMedia('(max-width: 899px)');
  var nav = document.getElementById('nav-mobile');
  var suche = document.querySelector('[data-header-search]');
  var letzte = window.scrollY;
  var schwelle = 240; /* erst ab hier ausblenden — sonst zuckt es beim Start */
  var wartet = false;

  function pruefen() {
    wartet = false;
    var jetzt = window.scrollY;

    /* Nicht ausblenden, solange Menue oder Suche offen sind — sonst
       verschwinden sie unter dem Finger (auch die Handy-Tastatur scrollt). */
    var offen = (nav && !nav.hasAttribute('hidden')) || (suche && suche.open);

    if (!mobil.matches || offen || jetzt <= schwelle) {
      document.documentElement.classList.remove('kopf-weg');
    } else if (jetzt > letzte + 6) {
      document.documentElement.classList.add('kopf-weg');
    } else if (jetzt < letzte - 6) {
      document.documentElement.classList.remove('kopf-weg');
    }

    letzte = jetzt;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (wartet) return;
      wartet = true;
      window.requestAnimationFrame(pruefen);
    },
    { passive: true }
  );

  mobil.addEventListener('change', pruefen);
})();

/**
 * Suchvorschlaege (RL-20) — Combobox nach dem ARIA-Muster „Combobox with
 * Listbox Popup" (WAI-ARIA APG).
 *
 *   Tippen (ab 2 Zeichen)  holt Vorschlaege, 250 ms nach dem letzten Zeichen
 *   Pfeil runter / hoch    waehlt die naechste / vorige Option (rundum)
 *   Enter                  oeffnet die gewaehlte Option, sonst normale Suche
 *   Escape                 schliesst die Liste; ein zweites Escape die Suche
 *   Tab                    verlaesst das Feld, die Liste geht zu
 *
 * Der Fokus bleibt immer im Eingabefeld; die aktive Option zeigt
 * `aria-activedescendant`. So tippt man weiter, waehrend man waehlt.
 *
 * Die Vorschlaege kommen als HTML aus der Section `predictive-search`
 * (Section Rendering API) — Bild, Linie und Texte also aus Liquid. Bei einem
 * Fehler bleibt einfach die Liste zu: Das Formular sucht ohnehin weiter.
 */
(function () {
  'use strict';

  var formulare = document.querySelectorAll('[data-suchfeld]');
  if (!formulare.length || !window.fetch || !window.DOMParser) return;

  var parser = new DOMParser();

  formulare.forEach(function (form) {
    var feld = form.querySelector('[data-suchfeld-eingabe]');
    var liste = form.querySelector('[data-vorschlaege]');
    var status = form.querySelector('[data-vorschlaege-status]');
    var basisUrl = form.getAttribute('data-vorschlag-url');
    if (!feld || !liste || !basisUrl) return;

    var zwischenspeicher = {};
    var laufend = null;
    var timer = null;
    var aktiv = -1;
    var optionen = [];

    feld.setAttribute('role', 'combobox');
    feld.setAttribute('aria-autocomplete', 'list');
    feld.setAttribute('aria-expanded', 'false');
    feld.setAttribute('aria-controls', liste.id);

    function markieren(index) {
      optionen.forEach(function (option, i) {
        option.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      aktiv = index;
      if (index >= 0 && optionen[index]) {
        feld.setAttribute('aria-activedescendant', optionen[index].id);
        optionen[index].scrollIntoView({ block: 'nearest' });
      } else {
        feld.removeAttribute('aria-activedescendant');
      }
    }

    function schliessen() {
      liste.hidden = true;
      feld.setAttribute('aria-expanded', 'false');
      markieren(-1);
    }

    function oeffnen() {
      if (!optionen.length) return;
      liste.hidden = false;
      feld.setAttribute('aria-expanded', 'true');
    }

    function ansagen(text) {
      if (!status) return;
      /* Gleicher Text zweimal wird nicht erneut vorgelesen — kurz leeren. */
      status.textContent = '';
      window.setTimeout(function () {
        status.textContent = text || '';
      }, 60);
    }

    function einsetzen(html) {
      var doc = parser.parseFromString(html, 'text/html');
      var antwort = doc.querySelector('[data-vorschlaege-antwort]');
      liste.innerHTML = '';
      optionen = [];
      if (!antwort) {
        schliessen();
        return;
      }

      antwort.querySelectorAll('[role="option"]').forEach(function (option, i) {
        option.id = liste.id + '-' + i;
        liste.appendChild(document.importNode(option, true));
      });
      optionen = Array.prototype.slice.call(liste.querySelectorAll('[role="option"]'));
      markieren(-1);

      if (optionen.length) {
        oeffnen();
      } else {
        schliessen();
      }
      ansagen(antwort.getAttribute('data-status'));
    }

    function holen(begriff) {
      if (zwischenspeicher[begriff]) {
        einsetzen(zwischenspeicher[begriff]);
        return;
      }
      if (laufend) laufend.abort();
      laufend = 'AbortController' in window ? new AbortController() : null;

      var url =
        basisUrl +
        '?q=' + encodeURIComponent(begriff) +
        '&resources[type]=product,collection,page,article' +
        '&resources[limit]=6' +
        '&resources[limit_scope]=all' +
        '&resources[options][unavailable_products]=last' +
        '&section_id=predictive-search';

      fetch(url, laufend ? { signal: laufend.signal } : {})
        .then(function (antwort) {
          if (!antwort.ok) throw new Error(antwort.status);
          return antwort.text();
        })
        .then(function (html) {
          zwischenspeicher[begriff] = html;
          /* Nur einsetzen, wenn der Begriff noch stimmt. */
          if (feld.value.trim() === begriff) einsetzen(html);
        })
        .catch(function () {
          /* abgebrochen oder offline: Liste bleibt zu, Formular sucht weiter */
        });
    }

    function oeffneOption(option) {
      var ziel = option && option.getAttribute('data-url');
      if (ziel) window.location.href = ziel;
    }

    feld.addEventListener('input', function () {
      var begriff = feld.value.trim();
      window.clearTimeout(timer);
      if (begriff.length < 2) {
        if (laufend) laufend.abort();
        liste.innerHTML = '';
        optionen = [];
        schliessen();
        ansagen('');
        return;
      }
      timer = window.setTimeout(function () {
        holen(begriff);
      }, 250);
    });

    feld.addEventListener('keydown', function (event) {
      switch (event.key) {
        case 'ArrowDown':
          if (!optionen.length) return;
          event.preventDefault();
          oeffnen();
          markieren(aktiv + 1 >= optionen.length ? 0 : aktiv + 1);
          break;
        case 'ArrowUp':
          if (!optionen.length) return;
          event.preventDefault();
          oeffnen();
          markieren(aktiv - 1 < 0 ? optionen.length - 1 : aktiv - 1);
          break;
        case 'Enter':
          if (!liste.hidden && aktiv >= 0) {
            event.preventDefault();
            oeffneOption(optionen[aktiv]);
          }
          break;
        case 'Escape':
          if (!liste.hidden) {
            /* Erst die Liste, nicht gleich die ganze Suche. */
            event.preventDefault();
            event.stopPropagation();
            schliessen();
          }
          break;
        case 'Tab':
          schliessen();
          break;
      }
    });

    /* Maus und Finger. `mousedown` mit preventDefault haelt den Fokus im
       Feld, sonst schlosse `blur` die Liste, bevor der Klick ankommt. */
    liste.addEventListener('mousedown', function (event) {
      event.preventDefault();
    });

    liste.addEventListener('click', function (event) {
      oeffneOption(event.target.closest('[role="option"]'));
    });

    liste.addEventListener('mousemove', function (event) {
      var option = event.target.closest('[role="option"]');
      var index = optionen.indexOf(option);
      if (index >= 0 && index !== aktiv) markieren(index);
    });

    feld.addEventListener('blur', function () {
      window.setTimeout(schliessen, 120);
    });

    feld.addEventListener('focus', function () {
      if (optionen.length && feld.value.trim().length >= 2) oeffnen();
    });
  });
})();
